export default __webpack_public_path__ + "static/media/night_sky.d99bb1d7.jpg";